const OFFERS = [
  {
    id: 'nabidky-catering',
    image: '/img/catering_raut.jpg',      // skutečný catering Sobáčova (Robin 5. 11.: původní udírna „katastrofa“)
    badge: 'Catering',
    title: 'Catering na míru',
    period: 'Svatby · firemní · oslavy',
    desc: 'Pronájem celé restaurace nebo pouze catering — gril, pečené sele, koktejly.',
    cta: 'Nezávazná poptávka',
  },
  {
    id: 'nabidky-vouchery',
    image: '/img/voucher_darek.jpg',   // voucher = zážitek (tiny house, káď, sauna)
    badge: 'Dárek',
    title: 'Dárkové vouchery',
    period: 'Libovolná hodnota',
    desc: 'Voucher na ubytování a rybolov v PDF — platba kartou online. Pro narozeniny, výročí, Vánoce.',
    cta: 'Koupit voucher',
    href: '#koupit-voucher',
  },
]

export function Offers() {
  return (
    <section id="nabidky" className="py-20 md:py-28 bg-paper">
      <div className="container-x">
        <div className="max-w-3xl">
          <p className="h-eyebrow">Nabídky</p>
          <h2 className="h-display text-3xl md:text-[44px] mt-4">Akce &amp; nabídky</h2>
          <p className="mt-5 text-ink-700 text-base md:text-lg">
            Sezónní pobytové balíčky, dárkové vouchery a&nbsp;catering na míru.
          </p>
        </div>

        <div className="mt-12 grid md:grid-cols-2 gap-6 lg:gap-8">
          {OFFERS.map((o, i) => (
            <article
              key={i}
              id={(o as any).id}
              className="card transition-shadow grid md:grid-cols-2 gap-0"
            >
              <div className="relative">
                <img src={o.image} alt={o.title} className="w-full h-full object-cover aspect-[4/3] md:aspect-auto" />
                <span className="absolute top-3 left-3 bg-white/95 backdrop-blur-sm text-ink-900 text-[11px] font-semibold px-2.5 py-1 rounded-lg shadow-md">
                  {o.badge}
                </span>
              </div>
              <div className="p-6 flex flex-col justify-between">
                <div>
                  <h3 className="font-bold text-xl text-ink-900 tracking-tight leading-tight">
                    {o.title}
                  </h3>
                  <p className="mt-1.5 text-[12px] uppercase tracking-[0.14em] text-ink-700/70 font-semibold">
                    {o.period}
                  </p>
                  <p className="mt-4 text-ink-800 text-sm leading-relaxed">{o.desc}</p>
                </div>
                <div className="mt-5">
                  <a
                    href={(o as any).href || '#kontakt'}
                    className="btn-outline-dark text-[14px] py-2 px-4"
                  >
                    {o.cta}
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" className="w-3.5 h-3.5"><path d="M5 12h14M13 6l6 6-6 6" /></svg>
                  </a>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  )
}
